import React__default from 'react';
import { I as InlineTouchLinkButton, a as InlineTouchLinkAnchor } from '../TouchLink.styles-DBynuPNk.js';
import { T as TouchLinkBody } from '../TouchLinkBody-CqATf5Vk.js';

const InlineTouchLink = ({
  children,
  href,
  onClick
}) => {
  if (onClick) {
    return /*#__PURE__*/React__default.createElement(InlineTouchLinkButton, {
      onClick: onClick
    }, /*#__PURE__*/React__default.createElement(TouchLinkBody, null, children));
  }
  return /*#__PURE__*/React__default.createElement(InlineTouchLinkAnchor, {
    href: href
  }, /*#__PURE__*/React__default.createElement(TouchLinkBody, null, children));
};

export { InlineTouchLink as I };
//# sourceMappingURL=InlineTouchLink-DueDq2h5.js.map
